module.exports = __webpack_public_path__ + "static/media/tick.d76a1b2e.svg";